export const createSantaMembersAPI = (santaMembersAppDefId, sdk) => {
    const getAPI = () => new Promise((resolve, reject) => {
        sdk.getPublicAPI({ appDefinitionId: santaMembersAppDefId }, (api) => resolve(api), (err) => reject(`Failed to get santa members API: ${err}`));
    });
    const navigateToMember = (memberId, memberSlug) => getAPI().then((api) => api.navigateToMember({ memberId, ...(memberSlug ? { memberSlug } : {}) }));
    const navigateToSection = (section) => getAPI().then((api) => api.navigateToSection(section));
    const getNavigatableRoles = () => getAPI().then((api) => api.getNavigatableRoles());
    return {
        getAPI,
        navigateToMember,
        navigateToSection,
        getNavigatableRoles,
    };
};
//# sourceMappingURL=santa-members-api.js.map